import React from 'react';
import PropTypes from 'prop-types';

import PageTitle from 'components/PageTitle';
import Button from 'components/Button';
import Input from 'components/Input';

import edit from './images/edit.svg';
import timer from './images/timer.png';
import './styles.scss';

class PhoneConfirmation extends React.Component {
  constructor () {
    super();
    this.state = {
      countInputs: (new Array(4).fill('')),
      isDidntReceive: false,
      elapsed: 0,
      errorInput: false
    };
  }


  componentDidMount() {
    this.inputs[0].focus();
    this.timer = setInterval(this.tick, 50);
  }
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  tick = () => {
    this.setState({
      elapsed: new Date() - this.props.start
    });
    if ((Math.round(this.state.elapsed / 100) / 10) > 60) clearInterval(this.timer);
  }
  hasError = false;
  inputs = [];

  checkExpectedCode = () => this.props.phoneCode.filter(el => el !== '').join('').length !== 4;

  checkCodeError = () => {
    const expectedItem = this.props.expectedCode;
    const inputedItem = this.props.phoneCode.filter(el => el !== '').join('');
    console.log(`${inputedItem} ${expectedItem}`);
    if (expectedItem !== inputedItem) {
      this.setState({
        errorInput: true
      });
      this.hasError = false;
      return false;
    }
    this.setState({
      errorInput: false
    });
    this.hasError = true;
    return true;
  }

  showDidntReceive = () => {
    this.setState({ isDidntReceive: true });
  }

  moveCursorNext = (index) => {
    if (this.inputs[index + 1]) this.inputs[index + 1].focus();
  }
  moveCursorForvard = (index) => {
    if (this.inputs[index - 1]) this.inputs[index - 1].focus();
  }

  inputAction = index => (e) => {
    const countInputsTemp = this.state.countInputs;
    const chr = e.key;

    if (e.keyCode === 8) {
      countInputsTemp[index] = '';
      this.setState({ countInputs: countInputsTemp, errorInput: false });
      this.moveCursorForvard(index);
      this.props.inputChangeHandl(countInputsTemp);
      return;
    }
    if (chr == null) return;
    if (chr < '0' || chr > '9') {
      return;
    }

    if (countInputsTemp[index].length > 0) {
      if (countInputsTemp[index + 1] !== undefined) countInputsTemp[index + 1] = chr;
    }

    if (countInputsTemp[index].length === 0) countInputsTemp[index] = chr;

    this.setState({
      countInputs: countInputsTemp,
      errorInput: false
    });
    this.moveCursorNext(index);
    this.props.inputChangeHandl(countInputsTemp);
  }
  goToReceiveHandl = () => {
    const status = this.checkCodeError();
    if (status) {
      this.props.receiveHandl();
    }
  }
  render() {
    const {
      phoneCode, purePhone, editPhone, receivedAgainHandl
    } = this.props;
    const elapsed = Math.round(this.state.elapsed / 100);
    const seconds = (elapsed / 10).toFixed(1);
    return (
      <React.Fragment>
        <div className="phone-pure">
          <p className="pure-number">
            +1 { purePhone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3') }
          </p>
          <button
            className="pure-button"
            style={{ backgroundImage: `url(${edit})` }}
            onClick={editPhone(purePhone)}
          />
        </div>
        <PageTitle>
          { this.state.isDidntReceive ? 'Didn’t receive code?' : 'Type received code' }
        </PageTitle>

        <div className={`phone-confirmation -code ${this.state.isDidntReceive ? '-hide' : ''}`}>
          {
            this.state.countInputs.map((el, index) => (
                // eslint-disable-next-line
                <div className="phone-input" key={index}>
                  <Input
                    type="tel"
                    reference={(element) => { this.inputs.push(element); }}
                    isError={this.state.errorInput}
                    value={phoneCode[index] ? phoneCode[index] : ''}
                    keyAction={this.inputAction(index)}
                  />
                </div>
              ))
          }
          <p className="error-text">
            { this.state.errorInput ? 'Code is not valid' : '' }
          </p>
        </div>
        { !this.state.isDidntReceive ?
          <Button
            className="Continue-SMS-button"
            onClick={this.goToReceiveHandl}
            disabled={this.checkExpectedCode()}
          >
          Continue SMS
          </Button> : null }
        { !this.state.isDidntReceive ?
          <button
            className="button-received"
            onClick={this.showDidntReceive}
          >
            { 'I didn\'t receive code.' }
          </button> : null }

        { this.state.isDidntReceive ?
          <div>
            {seconds < 60 ?
              <div className="timer-resendSMS">
                <img src={timer} alt="timer_pic" />
                <div>
                  <div>You will be able to re-send SMS code after</div>
                  {`${(60 - seconds).toFixed(0)} sec.`}
                </div>
              </div> : <Button
                onClick={receivedAgainHandl}
                inline
                disabled={false}
              >
                Re-send SMS
                       </Button>
            }
          </div> : null }
        { this.state.isDidntReceive ?
          <div className="phone-support">
            <p className="support-or">
              or
            </p>
            <p className="support-detail">
              Contact customer support <br /> Mon - Fri, 9:00 - 18:00
            </p>

            <p className="support-phone">
              +1 647 243-36-84
            </p>

            <p className="support-detail">
            Address: 27 Roytec Rd Unit 9, Woodbridge,<br /> ON L4L 8E3
            </p>
          </div>
        : null }
        <div className="fieldForTest">
          {this.props.expectedCode}
        </div>
      </React.Fragment>
    );
  }
}


PhoneConfirmation.propTypes = {
  inputChangeHandl: PropTypes.func.isRequired,
  phoneCode: PropTypes.arrayOf(PropTypes.string).isRequired,
  purePhone: PropTypes.string.isRequired,
  expectedCode: PropTypes.string.isRequired,
  receiveHandl: PropTypes.func.isRequired,
  editPhone: PropTypes.func.isRequired,
  receivedAgainHandl: PropTypes.func.isRequired,
  start: PropTypes.number.isRequired
};

export default PhoneConfirmation;



// WEBPACK FOOTER //
// ./src/pages/Phone/components/PhoneConfirmation/index.js